import PropTypes from 'prop-types';

export const historyPropTypes = {
  listen: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
};

export const historyPropType = PropTypes.shape(historyPropTypes).isRequired;
